import "bootstrap/dist/css/bootstrap.min.css";
import Parse from 'parse';
import React, { useEffect, useState } from "react";
import { withTranslation } from 'react-i18next';
import { Redirect, Route, BrowserRouter as Router } from "react-router-dom";

import "./assets/main.scss";
import { analyticsRoutes, defaultRoutes } from "./routes";
import { authUser, checkUpdateMe, getSubdomain, purgeCache, updateUser } from "./services/userService";
import { redirectToG3IfNeeded } from "./utils/subdomain";
import withTracker from "./withTracker";

Parse.serverURL = '_';
Parse.initialize('_');
Parse.masterKey = '_';
const currentUser = authUser();

const keepSessionAlive = async () => {
  const currentUser = authUser();
  if (!currentUser) return;

  await checkUpdateMe(currentUser)
  return currentUser
};

const App = ({ t, i18n }) => {
  const [loggedIn, setLoggedIn] = useState(currentUser !== null);
  const [isAnalytics, setIsAnalytics] = useState(false);
  // const isAnalytics = loggedUser && loggedUser.roles.includes('analytics');

  const handleAuth = () => {
    setLoggedIn(true);
  };

  const PrivateRoute = ({component: Component, ...rest}) => {
    return (
      <Route {...rest} render={(props) => (
        loggedIn
          ? <Component {...props}/>
          : <Redirect to='/login'/>
      )}/>
    );
  }
  
  useEffect(() => {
    updateUser();
    const init = async () => {
      // Check if company is G3 and redirect to .app if on .com
      const redirected = await redirectToG3IfNeeded();
      if (redirected) return;

      const currUser = await keepSessionAlive();
      if(currUser && currUser.trackUi){
        console.log(currUser.companyCode, getSubdomain());
        if(currUser.company.code !== getSubdomain()){
          purgeCache();
          window.location.href = '/login';
          return;
        }

        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:4983841,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);

          const checkHotjar = () => {
            if (typeof h.hj !== 'undefined') {
              h.hj('identify', currUser.id, {
                userId: currUser.id,
                company: currUser.company.code,
                role: currUser.roles.join(','),
                email: currUser.email,
                firstName: currUser.firstName,
                lastName: currUser.lastName,
                dapartment: currUser.department,
                supervisorEmail: currUser.supervisor ? currUser.supervisor.email : '',
              });
            } else {
              setTimeout(checkHotjar, 100);
            }
          };
          checkHotjar();
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      }

      // setIsAnalytics(currUser.roles && currUser.roles.includes('analytics'));

      // setLoggedUser(currUser)
    };
  
    init();
    
  }, []);

  return (
  <Router basename={process.env.REACT_APP_BASENAME || ""}>
    <div>
      {!isAnalytics && defaultRoutes.map((route, index) => {
        if (!route.protected) {
          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              component={withTracker(props => {
                return (
                  <div>
                    <route.component handleAuth={handleAuth} {...props} />
                  </div>
                );
              })}
            />
          );
        } else {
          return (
            <PrivateRoute 
              key={index}
              path={route.path}
              exact={route.exact} 
              component={withTracker(props => {
                return (
                  <div>
                    <route.layout {...props}>
                      <route.component {...props} /> 
                    </route.layout>
                  </div>
                );
              })}/>
          );
        }

      })}
      {isAnalytics && analyticsRoutes.map((route, index) => {
        if (!route.protected) {
          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              component={withTracker(props => {
                return (
                  <div>
                    <route.component handleAuth={handleAuth} {...props} />
                  </div>
                );
              })}
            />
          );
        } else {
          return (
            <PrivateRoute 
              key={index}
              path={route.path}
              exact={route.exact} 
              component={withTracker(props => {
                return (
                  <div>
                    <route.layout {...props}>
                      <route.component {...props} /> 
                    </route.layout>
                  </div>
                );
              })}/>
          );
        }

      })}
    </div>
  </Router>
)};

export default withTranslation()(App)
